module.exports = __webpack_public_path__ + "img/delete_black_24dp.d50356e2.svg";